module.exports = __webpack_public_path__ + "img/6-1.8b10a1e2.png";